/** Gen1 Trunking Order 共通定数（Application / Validation / Preview 等で共有） */

export const SYSTEM_TYPE_NEW = 'New System';
export const SYSTEM_TYPE_EXISTING = 'Existing System';
export const SYSTEM_ID_FOR_NEW = 'new';
export const COUNTRY_LABEL_US_FALLBACK = 'US - United States';

/**
 * Repeater 行に表示する System ID（Admin OrderDetailRepeaterTable と同ロジック）
 * @param {Object} line - Gen1TrunkingOrderRepeaterSerial 互換
 * @param {string} systemType
 * @param {string} systemId
 * @param {string} otherSystemId
 */
export function displayRepeaterSystemId(
    line,
    systemType,
    systemId,
    otherSystemId
) {
    const ex = (line?.ExchangeSystemId ?? '').toString().trim();
    if (ex) return ex;
    const sid = (systemId ?? '').toString().trim();
    const oid = (otherSystemId ?? '').toString().trim();
    return systemType === SYSTEM_TYPE_NEW ? 'NEW' : sid || oid || '-';
}

export const GEN1_HEADER_FIELDS = [
    'ContactName',
    'ContactEmail',
    'AddressLineOne',
    'AddressLineTwo',
    'AddressLineThree',
    'City',
    'State',
    'Zip',
    'Country',
    'Telephone',
    'ManufactureRep',
    'SystemType',
    'SystemId',
    'DealerOrderNumber',
    'AdditionalNotes',
];

/** Trunking リセット時に gen1Order へ引き継ぐ Customer / Notes フィールド名 */
export const GEN1_ORDER_CUSTOMER_FIELDS = [
    'ContactName',
    'ContactEmail',
    'AddressLineOne',
    'AddressLineTwo',
    'AddressLineThree',
    'City',
    'State',
    'Zip',
    'Country',
    'Telephone',
    'ManufactureRep',
    'DealerOrderNumber',
    'AdditionalNotes',
];

export const USB_KEY_ITEM_FIELDS = [
    'Grade1UnlimitedAccessUsbKeyQty',
    'Grade2LimitedAccessUsbKeyQty',
    'SystemManagerSoftwareWithGrade1KeyQty',
    'SystemManagerSoftwareQty',
];

/** USB 関連の validationErrors キー */
export const USB_VALIDATION_ERROR_KEYS = [
    'usbKeyKpgkey01OrSm',
    'usbKeyAtLeastOne',
    ...USB_KEY_ITEM_FIELDS.map((f) => `usbKey_${f}`),
];
